/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let SuperSkuImport;
let ConsumerCardMessagingImport;
let MeasurementGuideImport;
let OrderSampleImport;
let GlobalCustomConfiguratorImport;
let ReturnsMessagingImport;
let AugmentedRealityImport;
let AisleBayImport;
let QuestionsAndAnswersAccordionBodyImport;
let RatingsAndReviewsAccordionBodyImport;
let SpecificationsAccordionBodyImport;
let ProductOverviewAccordionBodyImport;
let KeyProductFeaturesImport;

/** *********************
 * Aisle Bay
 ********************** */
export const AisleBayLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "aisle-bay" */
  '@thd-olt-component-react/aisle-bay')
  .then((module) => {
    const { AisleBay } = module;

    AisleBayImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <AisleBay {...props} />
        </QueryProvider>
      );
    };
  });

export const AisleBay = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay')).AisleBay
  : (props) => <AisleBayImport {...props} />;

export const AisleBayModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay')).AisleBay.dataModel
  : {};

/** *********************
 * Consumer Card Messaging
 ********************** */
export const ConsumerCardMessagingLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "consumer-card-messaging" */
  '@thd-olt-component-react/consumer-card-messaging')
  .then((module) => {
    const { ConsumerCardMessaging } = module;

    ConsumerCardMessagingImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <ConsumerCardMessaging {...props} />
        </QueryProvider>
      );
    };
  });

export const ConsumerCardMessaging = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging')).ConsumerCardMessaging
  : (props) => <ConsumerCardMessagingImport {...props} />;

export const ConsumerCardMessagingModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging')).ConsumerCardMessaging.dataModel
  : {};

/** *********************
 * Measurement Guide
 ********************** */
export const MeasurementGuideLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "measurement-guide" */
  '@thd-olt-component-react/measurement-guide')
  .then((module) => {
    const { MeasurementGuide } = module;

    MeasurementGuideImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <MeasurementGuide {...props} />
        </QueryProvider>
      );
    };
  });

export const MeasurementGuide = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/measurement-guide')).MeasurementGuide
  : (props) => <MeasurementGuideImport {...props} />;

export const MeasurementGuideModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/measurement-guide')).MeasurementGuide.dataModel
  : {};

/** *********************
 * Super Sku
 ********************** */
export const SuperSkuLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "super-sku" */
  '@thd-olt-component-react/super-sku')
  .then((module) => {
    const { SuperSku } = module;

    SuperSkuImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <SuperSku {...props} />
        </QueryProvider>
      );
    };
  });

export const SuperSku = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku')).SuperSku
  : (props) => <SuperSkuImport {...props} />;

export const SuperSkuModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku')).SuperSku.dataModel
  : {};

/** *********************
 * Order Sample
 ********************** */
export const OrderSampleLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "order-sample" */
  '@thd-olt-component-react/order-sample')
  .then((module) => {
    const { OrderSample } = module;

    OrderSampleImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <OrderSample {...props} />
        </QueryProvider>
      );
    };
  });

export const OrderSample = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample')).OrderSample
  : (props) => <OrderSampleImport {...props} />;

export const OrderSampleModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample')).OrderSample.dataModel
  : {};

/** *********************
 * Global Custom Configurator
 ********************** */
export const GlobalCustomConfiguratorLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "global-custom-configurator" */
  '@thd-olt-component-react/global-custom-configurator')
  .then((module) => {
    const { GlobalCustomConfigurator } = module;

    GlobalCustomConfiguratorImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <GlobalCustomConfigurator {...props} />
        </QueryProvider>
      );
    };
  });

export const GlobalCustomConfigurator = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator')).GlobalCustomConfigurator
  : (props) => <GlobalCustomConfiguratorImport {...props} />;

export const GlobalCustomConfiguratorModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator')).GlobalCustomConfigurator.dataModel
  : {};

/** *********************
 * Returns Messaging
 ********************** */
export const ReturnsMessagingLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "returns-messaging" */
  '@thd-olt-component-react/returns-messaging')
  .then((module) => {
    const { ReturnsMessaging } = module;

    ReturnsMessagingImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <ReturnsMessaging {...props} />
        </QueryProvider>
      );
    };
  });

export const ReturnsMessaging = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/returns-messaging')).ReturnsMessaging
  : (props) => <ReturnsMessagingImport {...props} />;

export const ReturnsMessagingModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/returns-messaging')).ReturnsMessaging.dataModel
  : {};

/** *********************
 * Augmented Reality
 ********************** */
export const AugmentedRealityLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "augmented-reality" */
  '@thd-olt-component-react/augmented-reality')
  .then((module) => {
    const { AugmentedReality } = module;

    AugmentedRealityImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <AugmentedReality {...props} />
        </QueryProvider>
      );
    };
  });

export const AugmentedReality = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality')).AugmentedReality
  : (props) => <AugmentedRealityImport {...props} />;

export const AugmentedRealityModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality')).AugmentedReality.dataModel
  : {};

/** *********************
 * Questions and Answers
 ********************** */
export const QuestionsAndAnswersAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "questions-and-answers" */
  '@thd-olt-component-react/questions-and-answers')
  .then((module) => {
    const { QuestionsAndAnswersAccordionBody } = module;

    QuestionsAndAnswersAccordionBodyImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <QuestionsAndAnswersAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const QuestionsAndAnswersAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers')).QuestionsAndAnswersAccordionBody
  : (props) => <QuestionsAndAnswersAccordionBodyImport {...props} />;

export const QuestionsAndAnswersAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers')).QuestionsAndAnswersAccordionBody.dataModel
  : {};

/** *********************
 * Ratings and Reviews
 ********************** */
export const RatingsAndReviewsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews" */
  '@thd-olt-component-react/ratings-and-reviews')
  .then((module) => {
    const { RatingsAndReviewsAccordionBody } = module;

    RatingsAndReviewsAccordionBodyImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <RatingsAndReviewsAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const RatingsAndReviewsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviewsAccordionBody
  : (props) => <RatingsAndReviewsAccordionBodyImport {...props} />;

export const RatingsAndReviewsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviewsAccordionBody.dataModel
  : {};

/** *********************
* Specifications
********************** */
export const SpecificationsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "specifications" */
  '@thd-olt-component-react/specifications')
  .then((module) => {
    const { SpecificationsAccordionBody } = module;

    SpecificationsAccordionBodyImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <SpecificationsAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const SpecificationsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications')).SpecificationsAccordionBody
  : (props) => <SpecificationsAccordionBodyImport {...props} />;

export const SpecificationsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications')).SpecificationsAccordionBody.dataModel
  : {};

/** *********************
* Product Overview
********************** */
export const ProductOverviewAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview')
  .then((module) => {
    const { ProductOverviewAccordionBody } = module;

    ProductOverviewAccordionBodyImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <ProductOverviewAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const ProductOverviewAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).ProductOverviewAccordionBody
  : (props) => <ProductOverviewAccordionBodyImport {...props} />;

export const ProductOverviewAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).ProductOverviewAccordionBody.dataModel
  : {};

/** *********************
* Key Product Features
********************** */
export const KeyProductFeaturesLoad = () => import(
  /*  webpackChunkName: "key-product-features" */
  '@thd-olt-component-react/key-product-features')
  .then((module) => {
    const { KeyProductFeatures } = module;
    KeyProductFeaturesImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="key-product-features">
          <KeyProductFeatures {...props} />
        </QueryProvider>
      );
    };
  });

export const KeyProductFeatures = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/key-product-features')).KeyProductFeatures
  : (props) => <KeyProductFeaturesImport {...props} />;